export default __webpack_public_path__ + "static/media/byko_resized.538df463.jpeg";